import React from 'react';
import { useTranslation } from 'react-i18next';
import { useLanguage, Language } from '../contexts/LanguageContext';
import '../styles/LanguagePicker.css';

const LanguagePicker: React.FC = () => {
  const { t } = useTranslation();
  const { currentLanguage, changeLanguage, availableLanguages } = useLanguage();

  const handleLanguageChange = (event: React.ChangeEvent<HTMLSelectElement>) => {
    const selectedLanguage = event.target.value as Language;
    changeLanguage(selectedLanguage);
  };

  const getLanguageInfo = (lang: Language) => {
    switch (lang) {
      case 'en':
        return {
          flag: '🇺🇸',
          label: t('form.language.english')
        };
      case 'et':
        return {
          flag: '🇪🇪',
          label: t('form.language.estonian')
        };
      default:
        return {
          flag: '🌐',
          label: lang
        };
    }
  };

  return (
    <div className="language-picker">
      <select
        id="language-select"
        value={currentLanguage}
        onChange={handleLanguageChange}
        className="language-select"
        aria-label={t('form.language.label')}
      >
        {availableLanguages.map((lang) => {
          const info = getLanguageInfo(lang);
          return (
            <option key={lang} value={lang}>
              {info.flag} {info.label}
            </option>
          );
        })}
      </select>
    </div>
  );
};

export default LanguagePicker;
